import { render, staticRenderFns } from "./PartnerInfo.vue?vue&type=template&id=ee610bac&"
import script from "./PartnerInfo.vue?vue&type=script&lang=ts&"
export * from "./PartnerInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports